import type { ReportChartProps } from '~/presentation/reports/common/Visualization';

import { useFilterByCampaignParams } from '~/presentation/reports/query/hooks';
import { BarChart as BarChartComponent } from '@shopify/polaris-viz';
import { EReportChart } from '~/presentation/reports/common/type';
import { ReportChartContainer } from '../ReportChartContainer';
import { useBarChartData } from '../../hooks/useBarChartData';
import { GSkeletonDisplayText } from '~/presentation/common';
import { isBrowser } from '~/utils';
import { useMemo } from 'react';

export interface IBarChartProps extends ReportChartProps {
  chartType: EReportChart;
}

export const BarChart: React.FC<IBarChartProps> = ({ isLoading, ...props }) => {
  const { hasFilterByCampaign } = useFilterByCampaignParams();

  const dimensions = useMemo(() => {
    if (props.chartType === EReportChart.SIMPLE_BAR) {
      return props.dimensions.slice(0, 1);
    }
    return props.dimensions;
  }, [props.dimensions, props.chartType]);

  const { seriesData, xAxisOptions, yAxisOptions, tooltipOptions, seriesNameFormatter } =
    useBarChartData({
      ...props,
      dimensions,
      hasFilterByCampaign,
    });

  const showLegend = !(hasFilterByCampaign && dimensions.length === 1);

  if (isLoading || !isBrowser()) {
    return <GSkeletonDisplayText height="350px" />;
  }

  return (
    <ReportChartContainer>
      <BarChartComponent
        id={`report-analytics-bar-chart-${props.chartType}`}
        data={seriesData}
        xAxisOptions={xAxisOptions}
        yAxisOptions={yAxisOptions}
        tooltipOptions={tooltipOptions}
        seriesNameFormatter={seriesNameFormatter}
        theme="Light"
        showLegend={showLegend}
      />
    </ReportChartContainer>
  );
};
